module.exports = __webpack_public_path__ + "img/identify02.112dfc5a.png";